// extracted by mini-css-extract-plugin
module.exports = {"show":"Show_show__2-Lf6"};